import * as React from "react";
import { SVGProps } from "react";
export const ArrowLeftUpIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width="1em"
        height="1em"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M6.5 6.562V13.25C6.5 13.458 6.427 13.635 6.281 13.781C6.135 13.927 5.958 14 5.75 14C5.542 14 5.365 13.927 5.219 13.781C5.073 13.635 5 13.458 5 13.25V4.75C5 4.542 5.073 4.365 5.219 4.219C5.365 4.073 5.542 4 5.75 4H14.25C14.458 4 14.635 4.073 14.781 4.219C14.927 4.365 15 4.542 15 4.75C15 4.958 14.927 5.135 14.781 5.281C14.635 5.427 14.458 5.5 14.25 5.5H7.562L15.479 13.417C15.6317 13.5697 15.708 13.7433 15.708 13.938C15.708 14.132 15.6317 14.3053 15.479 14.458C15.3263 14.6113 15.1493 14.688 14.948 14.688C14.7467 14.688 14.5697 14.6113 14.417 14.458L6.5 6.562Z"
            fill="currentColor"
        />
    </svg>
);
ArrowLeftUpIcon.displayName = "ArrowLeftUpIcon";
